import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as types from './types';
import * as api from './api';
import { xDaysAgo } from '../../util';

export const getUserActivityRequest = createAction(types.GET_USER_ACTIVITY.REQUEST);
export const getUserActivitySuccess = createAction(types.GET_USER_ACTIVITY.SUCCESS);
export const getUserActivityFailure = createAction(types.GET_USER_ACTIVITY.FAILURE);
export const fetchUsersActivityComplete = createAction(types.FETCH_USERS_ACTIVITY_COMPLETE);

export const getOrganizationActivity = createApiAction(
  types.GET_ORGANIZATION_ACTIVITY,
  (payload) => {
    const params = {
      ...payload,
      since: xDaysAgo({
        since: payload.since,
        until: payload.until,
      }),
    };

    return api.getOrganizationActivity(params).then(({ data }) => ({
      since: payload.since,
      until: payload.until,
      ...data[payload.orgId],
      orgId: payload.orgId,
    }));
  },
);

export const fetchOrganizationActivity = ({
  since, until, scope, username, orgId, dateFilterType,
}, meta) => (dispatch) => {
  const start = xDaysAgo({
    since,
    until,
  });
  return api.getOrganizationActivity({ since: start, until })
    .then(({ data }) => {
      dispatch(getUserActivitySuccess({
        username,
        since,
        until,
        scope,
        dateFilterType,
        ...data[orgId],
      }, meta));
      return { ...data[orgId], username };
    });
};

export const getActivitySuccess = (params, meta) => async (dispatch) => {
  await dispatch(getUserActivitySuccess(params, meta));
  return { ...params.data, username: params.username };
};

export const getUserActivity = (payload, meta) => (dispatch) => {
  const since = xDaysAgo({
    since: payload.since,
    until: payload.until,
  });
  const { until, username, level = 'user' } = payload;
  return api.getUserActivity({ since, until, level, username })
    .then(({ data }) => dispatch(getActivitySuccess({
      ...payload, ...data,
    }, meta)));
};

export const getTeamActivity = (payload, meta) => (dispatch) => {
  const since = xDaysAgo({
    since: payload.since,
    until: payload.until,
  });
  const { teamId, orgId, until } = payload;
  return api.getTeamsActivity({ teamIds: teamId, orgId, since, until })
    .then(({ data }) => dispatch(getActivitySuccess({
      ...payload, ...data[teamId],
    }, meta)));
};

export const cleanup = createAction(types.CLEAN_UP);
